import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreText?: string;
  moreTo?: string;
}

export default function SectionHeading({ title, subtitle, moreText, moreTo }: SectionHeadingProps) {
  return (
    <div className="mb-6 flex items-end justify-between gap-4">
      <div className="flex items-center gap-3">
        <span className="h-7 w-1.5 rounded-full bg-primary-500"></span>
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">{title}</h2>
          {subtitle && <p className="mt-1 text-sm text-foreground-600">{subtitle}</p>}
        </div>
      </div>
      {moreText && moreTo && (
        <Link
          to={moreTo}
          className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-accent-400 transition-colors hover:text-accent-500"
        >
          {moreText}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}